import { apiDelete, apiGet, apiPost } from './client.js';

export type StaffNotification = {
  id: string;
  tenantId: string;
  storeId: string;
  userId: string;
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  ticketId: string | null;
  inquiryId: string | null;
  readAt: string | null;
  dismissedAt: string | null;
  createdAt: string;
};

export const notificationsApi = {
  list(params?: { unreadOnly?: boolean; page?: number; pageSize?: number }) {
    const qs = new URLSearchParams();
    if (params?.unreadOnly) qs.set('unreadOnly', 'true');
    if (params?.page) qs.set('page', String(params.page));
    if (params?.pageSize) qs.set('pageSize', String(params.pageSize));
    const q = qs.toString();
    return apiGet<
      StaffNotification[],
      { total: number; unreadCount: number; page: number; pageSize: number }
    >(`/api/v1/notifications${q ? `?${q}` : ''}`).then((r) => ({
      data: r.data,
      meta: r.meta!,
    }));
  },

  unreadCount() {
    return apiGet<{ count: number }>('/api/v1/notifications/unread-count').then((r) => r.data);
  },

  markRead(body: { notificationIds?: string[]; all?: boolean }) {
    return apiPost<{ updated: number }, typeof body>('/api/v1/notifications/mark-read', body).then(
      (r) => r.data,
    );
  },

  dismiss(id: string) {
    return apiDelete(`/api/v1/notifications/${id}`);
  },
};
